<script setup>
defineProps({
  color: {
    type: String,
    default: "",
  },
  icon: {
    type: Object,
    required: true,
    component: String,
    color: String,
  },
  tooltip: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    required: true,
  },
  dateTime: {
    type: String,
    default: "",
  },
  subtitle: {
    type: String,
    default: "",
  },
  role: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  badges: {
    type: Array,
    default: () => [],
  },
});
</script>
<template>
  <div class="mb-3 timeline-block">
    <span
      class="timeline-step p-3"
      :class="`${$parent.dark ? 'bg-dark' : 'bg-'}${color}`"
    >
      <i v-tooltip.top="tooltip" :class="`text-${icon.color} text-gradient ${icon.component}`"></i>
    </span>
    <div class="timeline-content">
      <div class="d-flex flex-wrap align-items-center gap-2">
        <h6
          class="mb-0 text-sm font-weight-bold"
          :class="$parent.dark ? 'text-white' : 'text-dark'"
        >
          {{ title }}
        </h6>
        <span
          v-if="role"
          class="role-badge"
          :class="{ 'role-badge--dark': $parent.dark }"
        >
          {{ role }}
        </span>
      </div>
      <!-- <div class="d-flex align-items-center justify-content-start"> <div> <span v-for="(badge, index) of badges" :key="index" :class="`badge rounded-pill badge-sm bg-gradient-${icon.color} ms-1`" >{{ badge }}</span > </div> </div> -->
      <p
        v-if="subtitle"
        class="mb-0 text-xs font-weight-normal mt-1"
        :class="$parent.dark ? 'text-white opacity-75' : 'text-secondary'"
      >
        {{ subtitle }}
      </p>
      <p class="mb-0 text-xs text-secondary font-weight-normal">
        {{ dateTime }}
      </p>
      <p
        v-if="description"
        class="mt-1 mb-1 text-sm"
        style="white-space: pre-line;"
        :class="$parent.dark ? 'text-white' : 'text-dark'"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style scoped>
/* Badge role: kontras tinggi (teks #344767 di atas #e8ebfd ≈ 9:1) supaya tetap terbaca di ukuran kecil */
.role-badge {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.2;
  color: #344767;
  background-color: #e8ebfd;
  border: 1px solid #c5ccf9;
  border-radius: 1rem;
}

.role-badge--dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.35);
}
</style>
